module Meevo.Plugins.CompensationSettings {
    "use strict";

    /**
    * Main Section of CommissionDetail Section
    */
    export class CommissionDetailSection extends Meevo.Components.CommonClasses.SettingsSectionBase {

        public isMultiLocationPayrollEnabled: boolean = false;
        public excludeOvertimeFrequencyList = [Meevo.Model.OvertimeFrequencyEnum.CommissionPeriod];
        private compensationDataService: Meevo.Components.CommonClasses.ICompensationSettingsService;
        public clientCommissionExclusionList = [Meevo.Model.NewClientIndicatorEnum.NewtotheTenantNoServiceHistory];
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum,
            identityService: Components.Common.IIdentityService,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey)
            this.compensationDataService = this.dataService as Meevo.Components.CommonClasses.ICompensationSettingsService;
            this.onInit();
    
        }
        activate(): void {
            super.activate();
        }
        onInit = () => {
            this.compensationDataService.getPayrollSettings(false).then((res: Meevo.Model.IPayrollSettings) => {
                this.isMultiLocationPayrollEnabled = res.periodSettings.enableMultiLocationPayroll;
        
            })
        }

       
    }
}